var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("span", {
    staticClass: "flex flex-shrink-0 h-2 w-2 rounded-full",
    class: _vm.styleClasses,
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }